import React, { useEffect, useRef, useState } from "react";
import "./NumberInput.css";
import debounce from "lodash.debounce";

const NumberInput_fontsize = ({
  label,
  postLabel,
  onChange,
  value,
  min,
  max,
  onFocusOut,
  disabled,
  step,
  key,
  customWidth,
}) => {
  // localValue = instant display; valueRef = synchronous math base so rapid
  // clicks build on the latest value (no skip / no revert); interactingRef
  // ignores the parent's laggy echo for a short window.
  const [localValue, setLocalValue] = useState(value);
  const valueRef = useRef(value);
  const interactingRef = useRef(false);
  const idleTimerRef = useRef(null);

  useEffect(() => {
    if (!interactingRef.current) {
      valueRef.current = value;
      setLocalValue(value);
    }
  }, [value]);

  const debouncedFocusOutRef = useRef(
    debounce(() => {
      if (onFocusOut) onFocusOut();
    }, 1000)
  );

  useEffect(() => {
    return () => {
      debouncedFocusOutRef.current.cancel();
      clearTimeout(idleTimerRef.current);
    };
  }, []);

  const markInteracting = () => {
    interactingRef.current = true;
    clearTimeout(idleTimerRef.current);
    idleTimerRef.current = setTimeout(() => {
      interactingRef.current = false;
    }, 400);
  };

  const updateValue = (newValue) => {
    if (disabled || !onChange) return;
    const clampedValue = Math.max(
      isNaN(min) ? -Infinity : min,
      Math.min(isNaN(max) ? Infinity : max, newValue)
    );
    if (clampedValue === Number(valueRef.current)) return;
    valueRef.current = clampedValue;
    setLocalValue(clampedValue);
    markInteracting();
    onChange(clampedValue);
    debouncedFocusOutRef.current();
  };

  const handleInc = (event) => {
    if (event) event.preventDefault();
    if (disabled || !onChange) return;
    updateValue(Number(valueRef.current) + 1);
  };

  const handleDec = (event) => {
    if (event) event.preventDefault();
    if (disabled || !onChange) return;
    updateValue(Number(valueRef.current) - 1);
  };

  const handleMouseWheel = (event) => {
    event.preventDefault();
  };

  const handleKeyDown = (event) => {
    if (disabled || !onChange) return;
    if (event.key === "ArrowUp") {
      event.preventDefault();
      updateValue(Number(valueRef.current) + 1);
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      updateValue(Number(valueRef.current) - 1);
    }
  };

  const handleChange = (evt) => {
    if (disabled || !onChange) return;
    const inputVal = evt.target.value;
    setLocalValue(inputVal);
    markInteracting();
    if (inputVal !== "" && !isNaN(inputVal)) {
      valueRef.current = Number(inputVal);
      onChange(Number(inputVal));
    }
  };

  return (
    <div className="numContainer">
      {label && <span className="number-label mr-[6px]">{label}</span>}

      <div className={"numContainer-componentFont " + (disabled ? "disabled" : "") + " " + customWidth}>
        <span className="inputContainer">
          <input
            type="number"
            className="form-control"
            value={localValue}
            step={step}
            min={min}
            max={max}
            key={key}
            onChange={handleChange}
            onWheel={handleMouseWheel}
            onKeyDown={handleKeyDown}
            onBlur={onFocusOut}
            disabled={disabled}
          />
          {/* {postLabel  } */}
          <span className={`postLValue ${postLabel ? "hasValue" : ""}`}>
          {postLabel}
        </span>
        </span>

        <div className="btnContainer">
          <div onClick={handleInc} className="top-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon-tabler icon-tabler-chevron-up"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="#c7c0d9"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <polyline points="6 15 12 9 18 15"></polyline>
            </svg>
          </div>
          <div onClick={handleDec} className="down-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="icon-tabler icon-tabler-chevron-down"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="#c7c0d9"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NumberInput_fontsize;